import { object, string, func, bool, oneOfType } from 'prop-types'
import { useEffect, useState } from 'react'
import { upload } from '@util/xhrAPI'
import Div from '@ui/layout/Div'
import Icon from '@ui/elements/Icon'
import Image from '@ui/elements/Image'
import Alert from '@ui/elements/Alert'
import ProgressBar from '@ui/elements/ProgressBar'

const FileType = ({
  blobPoster = false,
  onChange = () => { },
  simpleInput = false,
  disabled = false,
  name,
  cssClass,
  alt,
  label,
  error,
  targetUrl,
  fileType = 'image',
  help,
  id = null
}) => {
  const [file, setFile] = useState(blobPoster)
  const [blob, setBlob] = useState(blobPoster)
  const [progress, setProgress] = useState(0)
  const [isUploading, setUploading] = useState(false)

  const allowedExensions = {
    'image': 'image/*',
    'document': 'application/pdf',
    'sheet': 'text/csv'
  }

  const getBlob = inputFile => {
    const reader = new FileReader()
    reader.addEventListener(
      "load",
      () => {
        setFile(reader.result)
        setBlob(true)
      },
      false,
    );

    if (inputFile) {
      reader.readAsDataURL(inputFile)
    }
  }

  const validateImageExtension = file => {
    var allowedExtensions = ["jpg", "jpeg", "png"];
    var extension = file.name.split('.').pop().toLowerCase();

    return allowedExtensions.indexOf(extension) !== -1;
  }

  const uploadFile = async file => {
    if (
      ('image' === fileType && validateImageExtension(file))
      || ('image' !== fileType && allowedExensions[fileType].split(',').indexOf(file.type) >= 0)
    ) {
      setUploading(true)
      await upload(targetUrl, file, response => {
        if (Array.isArray(response.data)) {
          response.data.forEach(item => {
            onChange(name, item)
          })
        }
      }, setProgress)
      setUploading(false)
    }
  }

  const getUploadedFile = e => {
    const inputFile = e.target.files[0]
    if (inputFile) {
      getBlob(inputFile)
      uploadFile(inputFile)
    }
  }

  useEffect(() => {
    setBlob(blobPoster)
  }, [blobPoster])

  if (simpleInput) {
    return (
      <input type='file' name={name} onChange={onChange} className={cssClass} accept={allowedExensions[fileType]} />
    )
  } else {
    return (
      <Div cssClass={`field ${cssClass}`}>
        <Div cssClass="file is-info withPreview">
          {'image' === fileType && <>
            <Div cssClass='imagePreview'>
              {file && blob && <Image src={file} cssFigureClass='imagePreview' alt={alt} />}
              {isUploading && <ProgressBar cssClass={`uploadProgress ${progress === 100 ? 'is-hidden' : ''}`} progress={progress} />}
            </Div>
          </>}
          <label className="file-label" htmlFor={id ?? `input-${name}`}>
            <input
              className='file-input'
              id={id ?? `input-${name}`}
              type="file"
              name={name}
              onChange={getUploadedFile}
              disabled={disabled}
              accept={allowedExensions[fileType]}
            />
            <span className="file-cta">
              <Icon icon='icon-picture' spanClass='file-icon' />
              <span className="file-label">
                {label}
              </span>
            </span>
          </label>
        </Div>
        {help && <p className='help'>{help}</p>}
        {error && <Alert cssClass='clear' type='is-danger' message={error} />}
      </Div>
    )
  }
}

FileType.propTypes = {
  alt: string,
  id: string,
  label: string,
  name: string,
  blobPoster: oneOfType([bool, string]),
  error: string,
  value: oneOfType([object, bool]),
  onChange: func,
  cssClass: string,
  disabled: bool,
  inputRef: object,
  simpleInput: bool,
  targetUrl: string,
  help: string,
  fileType: string,
}

export default FileType
